/* eslint-disable no-param-reassign */
import Tabs from "../_alpine-library/tabs.js";

const scrollToNavItem = (vm) => {
  const $scroller = vm.$refs.scroller;
  // console.log('scroller', $scroller);

  const $activeEl = $scroller.querySelector(`[data-tab="${vm.activeTab}"]`);
  // console.log('$activeEl', $activeEl);
  const parentLeft = $scroller.offsetLeft;
  const childLeft = $activeEl.offsetLeft;
  const newLeft = childLeft - parentLeft;

  // console.log('parentLeft', parentLeft);
  // console.log('childLeft', childLeft);
  // console.log('newLeft', newLeft);

  $scroller.scrollTo({
    top: 0,
    left: newLeft,
    behavior: "smooth"
  });
};

const handleResize = (vm) => {
  scrollToNavItem(vm);
};

export function tab(config, Alpine) {
  const component = new Tabs();

  return {
    ...component,
    afterChange(vm) {
      scrollToNavItem(vm);
    },
    onResize(vm) {
      window.addEventListener(
        "resize",
        window.Alpine.debounce(() => {
          handleResize(vm);
        }, 250)
      );
    }
  };
}
